import { render, staticRenderFns } from "./AssignMaintainerToOrg.vue?vue&type=template&id=7e6f6c20&scoped=true"
import script from "./AssignMaintainerToOrg.vue?vue&type=script&lang=js"
export * from "./AssignMaintainerToOrg.vue?vue&type=script&lang=js"
import style0 from "./AssignMaintainerToOrg.vue?vue&type=style&index=0&id=7e6f6c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6f6c20",
  null
  
)

export default component.exports